let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("e5BVK")).then(() => parcelRequire('bULsa'));